import tokens from '@ifood/pomodoro-tokens';
import React, { FC } from 'react';

import { Box } from 'modules/UI';

import { Frame, Wrapper } from './styles';

type PropTypes = React.IframeHTMLAttributes<HTMLIFrameElement>;

export const IFrame: FC<PropTypes> = (props) => (
  <Box maxWidth="588px" my={tokens.space.large}>
    <Wrapper>
      <Frame {...props} />
    </Wrapper>
  </Box>
);
